export default __webpack_public_path__ + "tab2_videoe966cb.mp4";